/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIPromptFromJSON, ApiAIPromptToJSON, } from './ApiAIPrompt';
export function ApiAISessionFromJSON(json) {
    return ApiAISessionFromJSONTyped(json, false);
}
export function ApiAISessionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'openaiConversationId': !exists(json, 'openaiConversationId') ? undefined : json['openaiConversationId'],
        'prompts': !exists(json, 'prompts') ? undefined : (json['prompts'].map(ApiAIPromptFromJSON)),
        'useMcpAgent': !exists(json, 'useMcpAgent') ? undefined : json['useMcpAgent'],
    };
}
export function ApiAISessionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'openaiConversationId': value.openaiConversationId,
        'prompts': value.prompts === undefined ? undefined : (value.prompts.map(ApiAIPromptToJSON)),
        'useMcpAgent': value.useMcpAgent,
    };
}
